const moduleMap = {
	"App": () => {
		return Promise.all([__webpack_require__.e(1871), __webpack_require__.e(4914), __webpack_require__.e(9651), __webpack_require__.e(8316), __webpack_require__.e(9474)]).then(() => (() => ((__webpack_require__(4111)))));
	},
	"NavigationItem": () => {
		return Promise.all([__webpack_require__.e(1871), __webpack_require__.e(4391), __webpack_require__.e(4914), __webpack_require__.e(9651), __webpack_require__.e(9227), __webpack_require__.e(2682)]).then(() => (() => ((__webpack_require__(301)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});